import get from 'lodash/get';
import { REFRESH_TOKEN_PROCESS_DONE } from 'data/types/event.types';
import getAccessToken from 'helpers/getAccessToken';
import { isProcessingFlagStale, clearProcessingFlag } from 'helpers/refreshTokenUtils';

let timer = null;

// eslint-disable-next-line
export default () => () => (next) => (action) => {
  const skipAuth = get(action, 'payload.skipAuth', false);
  if (skipAuth) return next(action);

  const isProcessing = localStorage.getItem('refreshTokenProcessing');

  if (isProcessing) {
    // Clear stale flags from crashed tabs
    if (isProcessingFlagStale()) {
      clearProcessingFlag();
      return next(action);
    }

    // If processing but no refreshToken exists, clear and sign out
    const refreshToken = localStorage.getItem('refreshToken');
    if (!refreshToken) {
      clearProcessingFlag();
      return next({
        type: 'SIGN_OUT',
        data: {},
      });
    }

    if (!timer) {
      const fiveSeconds = 5000;
      timer = setTimeout(async () => {
        timer = null;
        await getAccessToken(true);
      }, fiveSeconds);
    }
    const handler = ({ detail }) => {
      clearTimeout(timer);
      timer = null;
      window.removeEventListener(REFRESH_TOKEN_PROCESS_DONE, handler);
      next({
        ...(action || {}),
        accessToken: detail?.accessToken,
      });
    };
    window.addEventListener(REFRESH_TOKEN_PROCESS_DONE, handler);
  } else {
    next(action);
  }
};
